'use client'

import React, { useState, useEffect, useRef } from "react"
import dayjs from "dayjs";
import { isCampaignActive } from "@/lib/campaignWindow";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { useGlobalContext } from "../context/provider";
import Hashids from "hashids";
import CryptoJS from "crypto-js";
import { getLocalStorage, setLocalStorage } from "@/lib/localStorage";
import { imageLoader } from "@/lib/functionloader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import FlashSaleSVG from "./FlashSaleSvg";
import { AxiosPostData } from '../context/axiosfunction'
import { useAddToCart } from './AddCart'


const CardEbook = ({ Ebookdata, type }) => {
    const cardRef = useRef(null);
    const [width, setWidth] = useState(0);
    const router = useRouter()
    const { privateKey, refreshCart, DataShalve, setDataShalve, DataUser, API, headers, Token, screen } = useGlobalContext()
    const { addToCart, contextHolder } = useAddToCart();
    const [timeLeft, setTimeLeft] = useState('')
    const [campaign, setCampaign] = useState(false)

    useEffect(() => {
        if (cardRef.current) {
            const card = cardRef.current.offsetWidth;
            setWidth(card);
        }
    }, []);

    const set_data = type === 'SearchBook' ? {
        name: Array.isArray(Ebookdata?.Edata) ? Ebookdata?.Edata[0]?.name : (Ebookdata?.Edata?.name || Ebookdata?.['Edata.name']),
        check_new: dayjs().diff(dayjs(Ebookdata?.release_date || Ebookdata?.createdAt), 'day') < 15,
        best_seller: Ebookdata?.bestseller == '1',
        book_image: Ebookdata?.book_image,
        series_number: Ebookdata?.series_number,
        partner: Array.isArray(Ebookdata?.Edata) ? Ebookdata?.Edata[0]?.partner?.name : (Ebookdata?.Edata?.partner?.name || Ebookdata?.['Edata.partner.name']),
        author: Array.isArray(Ebookdata?.Edata) ? Ebookdata?.Edata[0]?.author?.name : (Ebookdata?.Edata?.author?.name || Ebookdata?.['Edata.author.name']),
        partner_id: Array.isArray(Ebookdata?.Edata) ? Ebookdata?.Edata[0]?.partner?.id : (Ebookdata?.Edata?.partner?.id || Ebookdata?.['Edata.partner.id']),
        coin_price: Number(Ebookdata?.coin_price),
        review: Number(Ebookdata?.score),
        book_series_id: Ebookdata?.id,
        dis_per: Number(Ebookdata?.dis_per),
        normal_price: Number(Ebookdata?.normal_price),
        campaign_type: Ebookdata?.Bcam?.campaign_type || Ebookdata?.['Bcam.campaign_type'],
        campaign_id: Ebookdata?.Bcam?.campaign_id || Ebookdata?.['Bcam.campaign_id'] || Ebookdata?.campaign_id,
        campaign_discount: Number(Ebookdata?.Bcam?.campaign_discount || Ebookdata?.['Bcam.campaign_discount'] || 0),
        cam_start: Ebookdata?.c_start || Ebookdata?.Bcam?.start_date || Ebookdata?.['Bcam.start_date'],
        cam_end: Ebookdata?.c_end || Ebookdata?.Bcam?.end_date || Ebookdata?.['Bcam.end_date'],
        packbook: Ebookdata?.packbook
    } : {
        name: Ebookdata['Edata.name'] || (Array.isArray(Ebookdata?.Edata) ? Ebookdata?.Edata[0]?.name : Ebookdata?.Edata?.name),
        check_new: dayjs().diff(dayjs(Ebookdata.createdAt || Ebookdata?.release_date), 'day') < 15,
        best_seller: Ebookdata.bestseller == '1',
        book_image: Ebookdata.book_image,
        series_number: Ebookdata.series_number,
        partner: Ebookdata['Edata.partner.name'] || (Array.isArray(Ebookdata?.Edata) ? Ebookdata?.Edata[0]?.partner?.name : Ebookdata?.Edata?.partner?.name),
        partner_id: Ebookdata['Edata.partner.id'] || (Array.isArray(Ebookdata?.Edata) ? Ebookdata?.Edata[0]?.partner?.id : Ebookdata?.Edata?.partner?.id),
        author: Ebookdata['Edata.author.name'] || (Array.isArray(Ebookdata?.Edata) ? Ebookdata?.Edata[0]?.author?.name : Ebookdata?.Edata?.author?.name),
        coin_price: Number(Ebookdata.coin_price),
        review: Number(Ebookdata.score),
        book_series_id: Ebookdata.id,
        dis_per: Number(Ebookdata.dis_per),
        normal_price: Number(Ebookdata.normal_price),
        campaign_type: Ebookdata['Bcam.campaign_type'] || Ebookdata?.Bcam?.campaign_type,
        campaign_id: Ebookdata['Bcam.campaign_id'] || Ebookdata?.Bcam?.campaign_id || Ebookdata?.campaign_id,
        campaign_discount: Number(Ebookdata['Bcam.campaign_discount'] || Ebookdata?.Bcam?.campaign_discount || 0),
        cam_start: Ebookdata.c_start || Ebookdata?.Bcam?.start_date || Ebookdata['Bcam.start_date'],
        cam_end: Ebookdata.c_end || Ebookdata?.Bcam?.end_date || Ebookdata['Bcam.end_date'],
        packbook: Ebookdata.packbook
    }
    // console.log(Ebookdata);

    // if (Ebookdata.book_id === 'YGu820260820155503') {
    //     console.log(set_data);
    //     console.log(campaign);


    // }


    useEffect(() => {
        if (!set_data.campaign_id || !set_data.cam_start) {
            setCampaign(false);
            return;
        }

        const checkEvent = () => {
            const isEvent = isCampaignActive(set_data.cam_start, set_data.cam_end);
            setCampaign(isEvent);
        };

        checkEvent();

        if (set_data.campaign_type !== 'FlashSale') {
            return;
        }

        const interval = setInterval(checkEvent, 1000); // ตรวจสอบทุกวินาที

        return () => clearInterval(interval); // ล้าง interval ตอน unmount
    }, [set_data.campaign_id, set_data.campaign_type, set_data.cam_start, set_data.cam_end]);


    const OnDirectLink = (id) => {
        const hashids = new Hashids(privateKey, 6)
        const encodedID = hashids.encode(id)

        const targetUrl =
            set_data.packbook === 'yes'
                ? `/pack_set/${encodedID}`
                : `/ebook/${encodedID}`

        window.open(targetUrl, "_blank")
    }


    const OnDirectLinkPartner = (id) => {
        const hashids = new Hashids(privateKey, 6)
        const encodedID = hashids.encode(id)

        window.open(`/marketplace/${encodedID}_p`, "_blank")
    }

    const handleClick = (e) => {
        const hashids = new Hashids(privateKey, 6);
        const encodedID = hashids.encode(set_data.book_series_id);

        const targetUrl =
            set_data.packbook === "yes"
                ? `/pack_set/${encodedID}`
                : `/ebook/${encodedID}`;

        // เปิดแท็บใหม่
        window.open(targetUrl, "_blank");
    };

    const isOwned = Array.isArray(DataShalve) && DataShalve.some(item => Number(item) === Number(set_data.book_series_id));

    return (
        <div className="text-left w-full flex flex-col justify-between">
            {contextHolder}
            <div>
                <div className="group">
                    <div
                        ref={cardRef}
                        className={`relative w-full ${set_data.packbook === "yes" ? "packset" : "bookset"
                            } card-img-hold rounded-[8px] cursor-pointer shadow-md overflow-hidden`}
                        role="link"
                        tabIndex={0}
                        onClick={handleClick}
                        onAuxClick={handleClick}
                    >
                        <Image
                            src={set_data.book_image}
                            loader={imageLoader}
                            alt={set_data.name || "cover"}
                            fill
                            className="object-contain object-center bg-card"
                            sizes="(max-width: 640px) 33vw, (max-width: 960px) 25vw, (max-width: 1440px) 16vw, 180px"
                            loading="lazy"
                            decoding="async"
                        />

                        {set_data.check_new && (
                            <div className="absolute top-0 right-[10px] w-[25px] md:w-[35px]">
                                <img
                                    src="https://eve-image.eveebook.com/image.eveebook/web_image/tag/new.png"
                                    alt="new_book"
                                    loading="lazy"
                                    decoding="async"
                                    width={35}
                                    height={35}
                                />
                            </div>
                        )}
                        {set_data.series_number > 0 && (
                            <div className="absolute top-[8px] left-[8px] z-10 px-2 py-0.5 text-[10px] md:text-[12px] font-bold text-white bg-[#EC008C] rounded shadow-md">
                                {set_data.series_number}
                            </div>
                        )}
                        {set_data.best_seller && (
                            <div className="absolute top-0 right-[10px] w-[25px] md:w-[35px]">
                                <img
                                    src="https://eve-image.eveebook.com/image.eveebook/web_image/tag/bestseller.png"
                                    alt="bestseller_book"
                                    loading="lazy"
                                    decoding="async"
                                    width={35}
                                    height={35}
                                />
                            </div>
                        )}
                        {campaign && set_data.cam_end && set_data.campaign_type === "FlashSale" && (
                            <div className="absolute bottom-0 left-0 w-full z-10 text-[14px] md:text-[16px] font-bold pointer-events-none">
                                <FlashSaleSVG className="w-full h-auto" endtime={set_data.cam_end} />
                            </div>
                        )}
                    </div>
                    <div onClick={handleClick} className="text-left cursor-pointer w-full">
                        <div className="text-primary text-[14px] sm:text-[16px] xl:text-[18px] group-hover:text-[#EC008C] transition-colors duration-500 ease-in-out w-full mt-2 overflow-hidden text-ellipsis whitespace-normal line-clamp-2 leading-snug min-h-[2.5rem] sm:min-h-[2.9rem]">
                            {set_data.name} {set_data.series_number > 0 ? 'เล่ม ' + set_data.series_number : ''}
                        </div>
                    </div>
                </div>

                <div className="text-left cursor-pointer w-full mt-1" onClick={() => OnDirectLinkPartner(set_data.partner_id)}>
                    <div className="text-disable text-[12px] xl:text-[14px] truncate">{set_data.partner}</div>
                </div>
            </div>

            <div className='flex flex-row items-end justify-between w-full mt-2'>
                {screen !== 'mobile' || (!DataUser || !isOwned) ?
                    <>
                        {(set_data.coin_price === set_data.normal_price && !(campaign && set_data.campaign_id)) ?
                            <div className="text-[12px] flex flex-wrap items-end xl:text-[14px] text-primary">
                                <span className="text-[16px] xl:text-[18px] ml-1 sm:ml-2"> {set_data.coin_price} </span> {screen === 'mobile' ? <span className="text-[16px] xl:text-[18px] mx-1 ">.-</span> : <span className="text-[12px] mx-[2px] sm:mx-[5px]">บาท</span>}
                            </div>
                            :
                            <>
                                {set_data.coin_price > 0 ?
                                    set_data.dis_per ? (
                                        <div className="text-[12px] flex flex-wrap items-end xl:text-[14px] text-primary">
                                            <div className="text-[12px] font-light xl:text-[14px] line-through decoration-2">{Math.floor(set_data.coin_price / ((100 - set_data.dis_per) / 100))}</div>
                                            <span className="text-[16px] xl:text-[18px] text-danger ml-1 sm:ml-2"> {set_data.coin_price} </span> {screen === 'mobile' ? <span className="text-[16px] xl:text-[18px] text-danger mx-1 ">.-</span> : <span className="text-[12px] text-danger mx-[2px] sm:mx-[5px]">บาท</span>}
                                        </div>
                                    ) : (campaign && set_data.campaign_id) ? (
                                        <div className="text-[12px] flex flex-wrap items-end xl:text-[14px] text-primary">
                                            <div className="text-[12px] font-light xl:text-[14px] line-through decoration-2">{set_data.normal_price}</div>
                                            {set_data.campaign_type === "Free" ? (
                                                <span className="text-[16px] xl:text-[18px] text-danger"> อ่านฟรี</span>
                                            ) : (
                                                <span className="text-[16px] xl:text-[18px] text-danger sm:mx-1 md:mx-2">
                                                    {Math.floor(set_data.coin_price * (100 - set_data.campaign_discount) / 100)} <span className="text-[12px] text-danger mx-[2px] md:mx-[5px]">บาท</span>
                                                </span>
                                            )}
                                        </div>
                                    ) : (
                                        ////// เอาไว้กลับมาแก้ ตอนมี preorder จริง
                                        <div className="text-[12px] xl:text-[14px] text-primary">
                                            <span className="text-[16px] xl:text-[18px]"> {set_data.packbook === 'yes' ?
                                                <div className="text-[12px] flex flex-wrap items-end xl:text-[14px] text-primary">
                                                    <div className="text-[12px] font-light xl:text-[14px] line-through decoration-2">
                                                        {set_data.normal_price}
                                                    </div>
                                                    <span className="text-[16px] xl:text-[18px] text-danger ml-1 sm:ml-2"> {set_data.coin_price} </span>
                                                    {screen === 'mobile' ?
                                                        <span className="text-[16px] xl:text-[18px] text-danger mx-1 ">.-</span> :
                                                        <span className="text-[12px] text-danger mx-[2px] sm:mx-[5px]">บาท</span>
                                                    }
                                                </div>
                                                : set_data.coin_price}</span>
                                            <span> บาท</span>
                                        </div>
                                    ) : (
                                        <div>
                                            <div className="text-[16px] xl:text-[18px] text-primary">อ่านฟรี</div>
                                        </div>
                                    )}
                            </>
                        }

                    </>

                    :
                    <div >

                    </div>
                }

                {(!DataUser || !isOwned) ?
                    <button onClick={() => addToCart(set_data)} className="cursor-pointer">
                        <img
                            className="h-[24px] mb-[5px]"
                            src="https://eve-image.eveebook.com/image.eveebook/mascot/basket1.png"
                            alt="add_basket"
                            loading="lazy"
                            decoding="async"
                            width={24}
                            height={24}
                        />
                    </button>
                    :
                    <span className="text-success text-[14px] "><FontAwesomeIcon icon={faCircleCheck} /> มีแล้ว</span>
                }

            </div>
        </div>
    )
}

export default CardEbook 